'use strict';
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.nodeStyleEditorFontSelectorWidget = function (nodeStyleEditorModel, fontFamilies) {
	if (!nodeStyleEditorModel || !fontFamilies) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const fontSelector = this,
			fontComponentTemplate = fontSelector.find('[data-mm-role=template]')
				.detach()
				.attr('data-mm-role', '');

		Object.keys(fontFamilies).forEach(fontFamily => {
			const fontComponent = fontComponentTemplate.clone();
			fontComponent.find('a')
				.text(fontFamily)
				.on('click', () => {
					nodeStyleEditorModel.setStyleValue('fontFamily', fontFamily);
				})
				.css({
					'font-family': fontFamilies[fontFamily]
				});
			fontSelector.append(fontComponent);
		});
	});

};

